import { Component, OnInit } from "@angular/core";
import { TreeNode } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { UnsubscribeComponent } from "../../generals/Components";
import { convertToTreeNodes, getSelectedTreeNodes, treePartialNodes } from "../../helpers/helper";
import { Category } from "../../interfaces/interfaces";
import { ApiService } from "../../services/api.service";

@Component({
    selector: 'app-categoryselectormodal',
    templateUrl: './categoryselectormodal.component.html',
    styleUrls: ['./categoryselectormodal.component.scss']
})
export class CategorySelectorModalComponent extends UnsubscribeComponent implements OnInit {

    mode: 'ALL'|'ONLYCHILDREN' = 'ONLYCHILDREN';

    categoriesTreeNodes: TreeNode<Category>[] = [];
    selectedCategoriesTreeNodes: TreeNode<Category>[] = [];
  
    set categories(categories: Category[]) {
      this.categoriesTreeNodes = convertToTreeNodes<Category>(categories);
    }
  
    set selectedCategoryIds(ids: number[]) {
      this.selectedCategoriesTreeNodes = getSelectedTreeNodes<Category>(this.categoriesTreeNodes, ids);
    }

    constructor(
        private apiService: ApiService,
        private config: DynamicDialogConfig,
        private ref: DynamicDialogRef
    ) {
        super();
        this.config.header = 'Kategóriák kiválasztása';
        this.mode = this.config.data.mode || 'ONLYCHILDREN';
    }

    ngOnInit(): void {
        this.init();
    }

    init(): void {
      this.loadData();
    }

    loadData(): void {
        this.apiService.getCategories().subscribe(({categories}) => {
            this.categories = categories;
            this.selectedCategoryIds = this.config.data.selectedIds;
            treePartialNodes(this.categoriesTreeNodes, this.selectedCategoriesTreeNodes);
        });
    }

    save(): void {
        let ids: number[] = [];
        if (this.mode === 'ONLYCHILDREN') {
            ids = this.selectedCategoriesTreeNodes.filter(node => node.children.length === 0).map((categoryTreeNode: TreeNode<Category>) => categoryTreeNode.data.id);
        } else {
            ids = this.selectedCategoriesTreeNodes.map((categoryTreeNode: TreeNode<Category>) => categoryTreeNode.data.id);
        }
        this.close(ids);
    }

    close(result: number[]): void {
        this.ref.close(result);
    }

}